import { render } from "./SetEmail.vue?vue&type=template&id=570bfe67&scoped=true"
import script from "./SetEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./SetEmail.vue?vue&type=script&setup=true&lang=js"

import "./SetEmail.vue?vue&type=style&index=0&id=570bfe67&scoped=true&lang=css"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570bfe67"],['__file',"src/views/me/SetEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "570bfe67"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('570bfe67', __exports__)) {
    console.log('reload')
    api.reload('570bfe67', __exports__)
  }
  
  module.hot.accept("./SetEmail.vue?vue&type=template&id=570bfe67&scoped=true", () => {
    console.log('re-render')
    api.rerender('570bfe67', render)
  })

}


export default __exports__